import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/products/Columns"
import { CrudProvider } from "@/context/crudContext"
import { withBranchColumn } from "@/components/Reports/ReportBranchFilter"

const branchProductColumns = withBranchColumn(columns)

// Every branch's products, this one included. Read-only: another branch's
// product cannot be opened or changed from this portal.
export default function BranchProductList() {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Branch Products</h5>
      </div>

      <CrudProvider>
        <CustomTable
          label="Branch Product"
          columns={branchProductColumns}
          apiPath="product/company"
          addBtn={false}
          action={false}
        />
      </CrudProvider>
    </>
  )
}
